export * from './piece-jointe.model';
export * from './piece-jointe-popup.service';
export * from './piece-jointe.service';
export * from './piece-jointe-dialog.component';
export * from './piece-jointe-delete-dialog.component';
export * from './piece-jointe-detail.component';
export * from './piece-jointe.component';
export * from './piece-jointe.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/index.ts